import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { GetQueuewaitingEvent } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { MdOutlineCalendarMonth, MdOutlineLocationOn } from "react-icons/md";
import { LuCamera } from "react-icons/lu";
import { BsThreeDots } from "react-icons/bs";
import { IoCameraOutline } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";

function EventList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState([]);
  // console.log("eventData", eventData);
  const [cameraCards, setcameraCards] = useState([]);
  const [cameraDetails, setCameraDetails] = useState([]);
  //console.log("cameraDetails", cameraDetails);
  const intervalRef = useRef(null);

  const fetchUseCase = async () => {
    try {
      const fetchCmarea = await GetQueuewaitingEvent(
        "68906edea673f16e978691f9"
      );
      if (fetchCmarea?.data?.status) {
        setCameraDetails(fetchCmarea?.data?.data);
      }
      //console.log("fetchCmarea", fetchCmarea);
    } catch (error) {
      //console.log("error", error);
    }
  };

  const AddPeople = async () => {
    try {
      const data = await axios.post("http://192.168.20.24:5000/people_count", {
        max_people: 6,
      });

      console.log("data", data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await axios.get(
        "https://visionemptrack.greymatterz.com/queuewaiting/q-waiting-logs"
      );
      //console.log("data", data);
      if (data?.data?.status === true) {
        setEventData(data?.data?.data);
        setcameraCards(data?.data?.summary?.video_feed_url);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUseCase();
    AddPeople();
    // intervalRef.current = setInterval(() => {
    //   fetchData();
    // }, 10000);

    // return () => clearInterval(intervalRef.current);
  }, []);
  return (
    <div>
      <aside className="mainSection">
        <div className="mb-5 pb-5 border-bottom">
          <div className="topEventFilter p-4">
            <div className="searchField">
              <button className="serchBtn">
                <FiSearch size={22} />
              </button>
              <input
                className="form-control"
                placeholder="Search name or address"
                type="text"
              />
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineLocationOn size={22} />
              </span>
              <select className="form-select">
                <option>Location</option>
                <option>Location1</option>
                <option>Location2</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineCalendarMonth size={22} />
              </span>
              <select className="form-select">
                <option>Sort By Date</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <IoCameraOutline size={22} />
              </span>
              <select className="form-select">
                <option>Camera</option>
              </select>
            </div>
          </div>

          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-0">
                Crowd Congestion({cameraDetails?.length || 0})
              </h3>
            </div>
          </div>

          <div className="px-4">
            <div className="allEventsItems">
              {cameraDetails &&
                cameraDetails.map((event) => {
                  const ele = event.camera_info;
                  return (
                    <div
                      className="itemsBox"
                      onMouseDown={(e) => {
                        e.currentTarget.setAttribute("data-down", "true");
                      }}
                      onMouseUp={(e) => {
                        const wasDown =
                          e.currentTarget.getAttribute("data-down");
                        if (
                          wasDown === "true" &&
                          window.getSelection().toString().length === 0
                        ) {
                          localStorage.setItem("rtspurl", ele?.rtsp_url);
                          navigate(`/crowd-event-logs/${ele?._id}`);
                        }
                        e.currentTarget.removeAttribute("data-down");
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="ident">Crowd Congestion</span>
                        <span onClick={(e) => e.stopPropagation()}>
                          <BsThreeDots size={28} />
                        </span>
                      </div>

                      <h3 className="my-3">
                        {ele?.camera_name} Event Type -{" "}
                        {event?.alert_types_info[0]?.alert_name}
                      </h3>

                      <p className="contIcon mb-2">
                        <span className="selectIcon">
                          <MdOutlineCalendarMonth size={22} />
                        </span>
                        {event?.created_at}
                      </p>

                      <p className="contIcon">
                        <span className="selectIcon">
                          <LuCamera size={22} />
                        </span>
                        {ele?.camera_name}
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default EventList;
